

module.exports = {
    None: -1,
    ActiveMaintenanceFull: 0,
    ActiveMaintenanceSmall:1,
    BillingAddress: 2,
    CardInfo: 3,
    ExpiredContractFull: 4,
    ExpiredContractSmall: 5,
    ExpiringContractFull: 6,
    ExpiringContractSmall: 7,
    Freemium: 8,
    MaintenanceOptions: 9,
    PaymentReview: 10,
    Paypal : 11,
    PurchaseCompleteSuccess: 12,
    Purchase: 13,
    StartTrialOptions: 14,
    TrialLicense: 15,
    TrialStarted: 16,
    ViewMisseddUpdates: 17,
    ContinueTrial: 18,

    SelectProducts:19,
    Netteller:20,

    FreemiumOverMaxVersion: 21,
    PreSelectProducts:22,

    UpgradeProduct: 23,
    CouldNotLoadMla: 24,

    GetHm3ForFree: 25,
    SelectHmAppsProducts:26,
    SelectHmAppVariantProducts:27,
};



// WEBPACK FOOTER //
// ./src/constants/page.js